import React from 'react';

import { CarouselCatalogueBlocContainer } from '../../components';
import { CarrouselCatalogueProps } from '.';

import enhancer from './carrousel-catalogue-enhancer';

const carrouselCatalogue: React.FC<CarrouselCatalogueProps> = React.memo(({ products }: CarrouselCatalogueProps) => {
    return <CarouselCatalogueBlocContainer products={products} />;
});

export const CarrouselCatalogue = enhancer(carrouselCatalogue);
